import { CloudTeams, sendError } from 'js/common/utils/bugsnag';

// Included on EasyList filter list
// https://easylist.to/index.html
const KNOWN_AD_BLOCK_URL = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

// Utility function to detect ad blocker browser plugins
export const handleAdBlocker = async (): Promise<void> => {
  try {
    await fetch(KNOWN_AD_BLOCK_URL, {
      method: 'HEAD',
      mode: 'no-cors',
    });
  } catch (error) {
    registerAdBlock(error);
  }
};

const registerAdBlock = (error): void => {
  // @TODO CLOUDP-85711
  // Send to MMS backend for "ad-block detected" event
  // https://jira.mongodb.org/browse/CLOUDP-85711

  // Add to Bugsnag metadata
  if (window?.bugsnagClient?.metaData) {
    window.bugsnagClient.metaData.isAdBlock = true;
  }

  // Sample and only send 1% of incidents, so as not to blow out Bugsnag
  const shouldSend = Math.random() < 0.01;
  if (shouldSend) {
    error.message = `Ad blocker detected! ${error.message}`;

    // Send to bugsnag
    sendError({ error, team: CloudTeams.AtlasGrowth });
  }
};
